import { StoreApi } from "zustand";

import { DEFAULT_PAGINATION_SIZE } from "@/v1/config/constants";

import {
  ISearchParams,
  ISearchParamsFilters,
  SortState,
} from "../types/global/SearchParams.interface";

import { Sort } from "./constants";
import { createStore } from "./createStore";
import { formatQuery } from "./formatQuery";

export interface IParamsStore extends ISearchParams {
  enabled?: boolean;
  query: string;
  set: StoreApi<ISearchParams>["setState"];
  updateFilter: (newFilter: { [id: string]: ISearchParamsFilters[] | undefined }) => void;
  removeFilter: (filterId: string) => void;
  updateQuery: () => void;
}

const DEFAULT_PARAMS = { size: DEFAULT_PAGINATION_SIZE, sort: ["name", Sort.ASC] as SortState };

export const createParamsStore = (params?: ISearchParams) =>
  createStore<IParamsStore>((set, get) => {
    const updateQuery = () => {
      const {
        set: _,
        updateFilter: _u,
        removeFilter: _r,
        enabled: _e,
        updateQuery: _uq,
        query,
        ...queryParams
      } = get();

      const newQuery = formatQuery(queryParams);

      if (newQuery !== query) {
        set({ query: newQuery });
      }
    };

    return {
      ...DEFAULT_PARAMS,
      ...params,
      enabled: false,
      query: "",
      updateFilter: (newFilterValues, updateQueryAfter = true) => {
        set(({ filters = {} }) => {
          return { page: undefined, filters: { ...filters, ...newFilterValues } };
        });

        if (updateQueryAfter) updateQuery();
      },
      removeFilter: (filterId, updateQueryAfter = true) => {
        set(({ filters = {} }) => {
          delete filters[filterId];

          Object.keys(filters).forEach((key) => {
            const filterValues = filters[key];

            const hasKey = filterValues?.some((filter) => {
              return filter.filterKey === filterId;
            });

            if (hasKey) {
              delete filters[key];
            }
          });

          return { filters: { ...filters } };
        });

        if (updateQueryAfter) updateQuery();
      },
      set: (props, updateQueryAfter = true) => {
        set(props);
        if (updateQueryAfter) updateQuery();
      },
      updateQuery,
    };
  });
